import React from 'react';
const SvgSafetySecurity = props => (
  <svg
    id="safety-security_svg__Layer_3"
    data-name="Layer 3"
    viewBox="0 0 390 390"
    {...props}
  >
    <path
      className="safety-security_svg__cls-1"
      d="M348 62.8S267.3 50.6 195 5C122.7 50.7 42 62.8 42 62.8 14.6 320.9 195 381 195 381s180.4-60.1 153-318.2zm-32.9 150.5c-10.4 34-26.6 63.9-48.3 89.1-28.1 32.5-58.3 48.7-71.7 54.8-13.1-6-42.6-21.8-70.2-53.1-22.1-25.1-38.7-55.1-49.4-89.2-12.2-39.2-16.6-84.1-12.9-133.5 26.7-5.8 80.3-20.2 132.5-50.6 52.3 30.3 105.8 44.8 132.5 50.6 3.6 48.8-.6 93.1-12.4 131.9z"
      strokeWidth={0}
    />
    <ellipse
      className="safety-security_svg__cls-1"
      cx={195}
      cy={136.5}
      rx={37.4}
      ry={39.3}
    />
    <path
      className="safety-security_svg__cls-1"
      d="M195 187.6c-37.2 0-67.4 24.6-67.4 54.9h134.8c0-30.3-30.2-54.9-67.4-54.9z"
    />
  </svg>
);
export default SvgSafetySecurity;
